import axios from 'axios';
import { useState } from 'react';

const useGetModuleScoringTableStructure = () => {
  const [isLoading, setIsLoading] = useState();

  const getScoringTableStructure = async (projectId, familyId, secondarySystemId) => {
    return await axios.get(`/standardization/${projectId}/modules/${familyId}/${secondarySystemId}`);
  };

  return {
    getScoringTableStructure,
  };
};

export default useGetModuleScoringTableStructure;
